import axios from 'axios';
import { isSessionExpired, clearSession, LOGIN_PATH } from '../lib/session';

// 1. Create a single, permanent axios instance.
function getApiUrl() {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Development environment
    return 'http://localhost:21001/apis/clients';
  } else {
    // Production environment
    return 'https://api.facinhosmurfs.com.br/apis/clients';
  }
}

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// 2. Use a request interceptor to dynamically add auth headers to every request.
// This is the core of the fix, ensuring every API call is authenticated.
api.interceptors.request.use(
  (config) => {
    const authString = localStorage.getItem('auth');
    if (authString) {
      const auth = JSON.parse(authString);
      // Attach the token and username to the headers if they exist.
      if (auth.token && auth.username) {
        config.headers['auth'] = auth.token;
        config.headers['username'] = auth.username;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Sessão vencida (401 fora do login): limpa o token e volta ao login em vez de deixar a tela quebrada.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (isSessionExpired(error)) {
      clearSession();
      if (window.location.pathname !== LOGIN_PATH) window.location.assign(LOGIN_PATH);
    }
    return Promise.reject(error);
  }
);

// Modo mock (só dev, localhost + ?mock=1). O if abaixo some do build de produção.
if (process.env.NODE_ENV !== 'production') {
  require('../dev/mock').setupMock(api);
}

// 3. Export a simple getAuth function for checking login status.
export function getAuth() {
  const authString = localStorage.getItem('auth');
  return authString ? JSON.parse(authString) : { token: null, username: null, auth: false };
}

// This function is now kept only for compatibility with the login component.
export function recreateApiWith(auth) {
  return api;
}

export default () => api;
